import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sendingShimentNotificationTitle: {
    description: 'sendingShimentNotificationTitle.sendingShipmentNotificationTitle',
    defaultMessage: 'Processing...',
    id: '7kAs/Q',
  },
  sendingShimentNotificationContent: {
    description: 'sendingShimentNotificationContent.sendingShipmentNotificationContent',
    defaultMessage: 'Sending Shipment Notification',
    id: 'zK7Z0l',
  },
  countsErrorTitle: {
    description: 'shipmentsNavEpics.countsErrorTitle',
    defaultMessage: 'Shipments Counts',
    id: 'LLx6t2',
  },
  countsErrorMessage: {
    description: 'shipmentsNavEpics.countsErrorMessage',
    defaultMessage: 'Something went wrong loading your shipments counts.',
    id: 'PlPpcc',
  },
  scheduleUspsSuccessNotificationMessage: {
    description: 'USPS Pickup Successful Schedule Request Notification',
    defaultMessage: 'USPS received and confirmed your scheduled pickup.',
    id: 'VPQgnk',
  },
  cancelUspsSuccessNotificationMessage: {
    description: 'USPS Pickup Successful Cancel Request Notification',
    defaultMessage: 'USPS has cancelled the previously scheduled pickup.',
    id: 'UQJi8F',
  },
  genericFallbackErrorMessage: {
    description: 'Generic Fallback Error Notification',
    defaultMessage: 'An unexpected error ocurred when processing this request. Please try again later.',
    id: 'Dh+k5v',
  },
});
